export default "__VITE_ASSET__CnGkSk4t__"